import React from 'react'
import * as R from 'remeda'

import { getDiffKey } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { type GroupsDiff, type GroupsDiffColumnKey } from '../utils'

export const useMapGroupsDiff = () => {
  const groupsDiffs = useAtomValueContext('groupsDiffs')

  return React.useCallback(
    <T>(
      mapFunc: (groupsDiff: GroupsDiff, index: number) => T,
    ): Record<GroupsDiffColumnKey, T> =>
      R.mapToObj(groupsDiffs, (groupsDiff, index) => [
        getDiffKey(groupsDiff),
        mapFunc(groupsDiff, index),
      ]),
    [groupsDiffs],
  )
}
